<template>
  <div class="dynamic-tabs">
    <div v-for="tab in visitedTabs" 
         :key="tab.path"
         :class="['tab-item', { active: isActive(tab) }]"
         @click="switchTab(tab)">
      {{ tab.title }}
      <span v-if="!tab.meta?.affix" 
            class="tab-close"
            @click.stop="closeTab(tab)">
        ×
      </span>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    visitedTabs() {
      //console.log('当前路由表:', JSON.stringify(this.$router.getRoutes()))
      return this.$store.state.tab?.visitedTabs || []
    }
  },
  methods: {
    isActive(tab) {
      return this.$route.path === tab.path
    },
    switchTab(tab) {
      if (this.$route.path !== tab.path) {
        this.$router.push(tab.path)
      }
    },
    async closeTab(tab) {
      await this.$store.dispatch('tab/removeTab', tab.path)
      if (this.isActive(tab)) {
        const lastTab = this.visitedTabs[this.visitedTabs.length - 1]
        this.$router.push(lastTab?.path || '/dashboard')
      }
    }
  }
}
</script>

<style scoped>
.dynamic-tabs {
  display: flex;
  background: #f5f5f5;
  padding: 0 15px;
  border-bottom: 1px solid #ddd;
}
.tab-item {
  padding: 8px 15px;
  cursor: pointer;
  position: relative;
  border: 1px solid transparent;
  border-bottom: none;
  margin-right: 5px;
  border-radius: 4px 4px 0 0;
  background: #fff;
  
  &.active {
    border-color: #ddd;
    border-bottom-color: #fff;
    background: #fff;
    color: #409EFF;
  }
}
.tab-close {
  margin-left: 8px;
  &:hover {
    color: #f56c6c;
  }
}
</style>